export const getScrollParent = (node: Node): Node | null | undefined => {
  const regex = /(auto|scroll)/;

  const parents = (
    _node: Node | null | undefined,
    ps: (Node | null | undefined)[]
  ): (Node | null | undefined)[] => {
    if (_node?.parentNode === null) {
      return ps;
    }

    return parents(_node?.parentNode, ps.concat([_node]));
  };

  const style = (_node: Node | null | undefined, prop: string) =>
    getComputedStyle(_node as Element, null).getPropertyValue(prop);

  const overflow = (_node: Node | null | undefined) =>
    style(_node, 'overflow') +
    style(_node, 'overflow-y') +
    style(_node, 'overflow-x');

  const scroll = (_node: Node | null | undefined) =>
    regex.test(overflow(_node));

  const scrollParent = (_node: Node) => {
    if (!(_node instanceof HTMLElement)) {
      return;
    }

    const ps = parents(_node.parentNode, []);

    for (let i = 0; i < ps.length; i += 1) {
      if (scroll(ps[i])) {
        return ps[i];
      }
    }

    return document.scrollingElement || document.documentElement;
  };

  return scrollParent(node);
};
